const cookieName = "CSEpisode2AssholeFeaturesSeen";
const secondsInWeek = 60 * 60 * 24 * 7;

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.cookie.split("; ").find((row) => row.startsWith(cookieName))) {
    cgClearSplashScreen();
    return;
  }
});

function cgClearSplashScreen() {
  const skull = document.getElementById('cg-splash-skull');
  skull.style.display = 'inline';
  skull.style.filter = 'brightness(0.25)';
  skull.style.transform = 'scaleX(-1)';
  skull.style.zIndex = 'calc(var(--cg-rectangle-z-index) - 111)';
  const splashScreen = document.getElementById("cg-splash-screen");
  splashScreen.parentElement.removeChild(splashScreen);
}

var cgAllowedIn = false;
setTimeout(() => cgAllowedIn = true, 4000)

const cgEnterStoreFromSplashScreen = () => {
  if (!cgAllowedIn) { console.log("YOU SHALL NOT PASS!"); return; }
  const skull = document.getElementById('cg-splash-skull');
  skull.style.filter = 'brightness(0.5)';
  var scale = 1.25;
  var iters = 13;

  /** @type {HTMLAudioElement} */
  const landerSong = new Audio("https://cdn.shopify.com/s/files/1/0812/4216/1443/files/FUNK_VAMP_09_18_2025.mp3?v=1764348359");
  if (!landerSong.paused) return;
  landerSong.load();
  landerSong.volume = 0.27;

  var flashSkullInterval = setInterval(() => {
    if (iters == 0) {
      clearInterval(flashSkullInterval);
      // Don't see it again for the next week
      document.cookie = `${cookieName}=true;max-age=${secondsInWeek}`;
      cgClearSplashScreen();
      landerSong.play();
      setTimeout(setupAssholePopup, 1000);
      return;
    }
    if (!skull.style.display) {
      skull.style.display = 'inline';
      skull.style.transform = `scale(${scale})`;
      scale *= 1.02;
    } else {
      iters--;
      skull.style.display = '';
    }
  }, 75);
};

// --- Asshole Popup Feature ---
function setupAssholePopup() {
  let dodgeCount = 0;
  const maxDodges = 4;
  let mouseX = 0, mouseY = 0;
  let currentDistance = 300; // Initial distance from mouse
  let isMoving = false; // Track if popup is currently moving

  const popup = document.createElement('div');
  popup.className = 'asshole-popup';

  // Calculate popup size in viewport units and constrain initial position
  const popupWidthVw = 60; // 60vw
  const popupHeightVh = 40; // 40vh
  const maxLeftVw = 100 - popupWidthVw;
  const maxTopVh = 100 - popupHeightVh;

  popup.style.top = `${Math.random() * maxTopVh}vh`;
  popup.style.left = `${Math.random() * maxLeftVw}vw`;

  // X button
  const closeBtn = document.createElement('div');
  closeBtn.innerText = '✖';
  closeBtn.className = 'asshole-popup-close';

  // Popup content
  popup.innerHTML = `
    <div class="asshole-popup-flash" style="color:#ffea00; text-shadow:2px 2px 0 #ff00cc, 0 0 8px #ffea00; font-size:1.4rem; margin-top:5px;">
      🔥 HOT SINGLES NEAR YOU 🔥
    </div>
    <img src="https://cdn.shopify.com/s/files/1/0812/4216/1443/files/CG_Issue2Boner.webp"
         alt="Hot Single"
         class="asshole-popup-image"
         style="cursor: pointer;">
    <div style='font-size:1.1rem; color:#ff00cc; margin-top:8px;'>
      Click now! Meet goblins in your area!
    </div>`;
  popup.appendChild(closeBtn);

  // Add click handler to the image
  const popupImage = popup.querySelector('.asshole-popup-image');
  popupImage.addEventListener('click', function(e) {
    e.stopPropagation(); // Prevent the wiggle from interceptClicks

    // Trigger wiggle animation
    wigglePopup();

    // Hide the image
    popupImage.style.display = 'none';

    // Change the popup content
    const flashText = popup.querySelector('.asshole-popup-flash');
    const bottomText = popup.querySelector('div[style*="font-size:1.1rem"]');

    flashText.innerHTML = '💰 HOT SINGLES ONLY DATE RICH GOBLINS 💰';
    flashText.style.fontSize = '1.8rem';
    flashText.style.marginTop = '10%';
    flashText.style.textAlign = 'center';

    bottomText.innerHTML = `
      <div style="font-size:1.4rem; color:#ff00cc; margin-top:15px; font-style:italic; text-align:center;">
        "If you want me, sugar, buy me an issue of Cafe Goblin"
      </div>
      <div style="font-size:1.1rem; color:#ffea00; margin-top:10px;">
        - Your Future Hot Goblin Date
      </div>`;

    // Make the image unclickable after first click
    popupImage.style.cursor = 'default';
    popupImage.removeEventListener('click', arguments.callee);
  });

  document.body.appendChild(popup);

  function wigglePopup() {
    popup.classList.add('wiggle');
    setTimeout(() => popup.classList.remove('wiggle'), 300);
  }

  function interceptClicks(e) {
    // Check if click is inside the popup
    const rect = popup.getBoundingClientRect();
    const x = e.clientX || (e.touches && e.touches[0].clientX);
    const y = e.clientY || (e.touches && e.touches[0].clientY);

    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      wigglePopup();
      return false;
    }
  }

  // Add event listeners to intercept all clicks and touches
  document.addEventListener('click', interceptClicks, true);
  document.addEventListener('touchstart', interceptClicks, true);
  document.addEventListener('touchend', interceptClicks, true);

  function moveAwayFromMouse() {
    if (dodgeCount >= maxDodges || isMoving) return; // Stop moving if no dodges left or already moving

    // Only check if mouse is over the close button
    const closeBtnRect = closeBtn.getBoundingClientRect();
    const mouseOverCloseBtn = mouseX >= closeBtnRect.left && mouseX <= closeBtnRect.right &&
                             mouseY >= closeBtnRect.top && mouseY <= closeBtnRect.bottom;

    if (mouseOverCloseBtn) {
      isMoving = true; // Start moving

      // Calculate popup size in viewport units
      const popupWidthVw = 60; // 60vw
      const popupHeightVh = 40; // 40vh

      // Generate random position ensuring popup stays fully on screen
      const maxLeftVw = 100 - popupWidthVw;
      const maxTopVh = 100 - popupHeightVh;

      let newTopVh = Math.random() * maxTopVh;
      let newLeftVw = Math.random() * maxLeftVw;

      popup.style.top = `${newTopVh}vh`;
      popup.style.left = `${newLeftVw}vw`;

      // After transition completes, increment dodge count and allow new moves
      setTimeout(() => {
        dodgeCount++;
        isMoving = false;
      }, 400); // Match the CSS transition duration

      // Gradually decrease distance to make it easier to catch
      currentDistance = Math.max(80, currentDistance * 0.95);
    }
  }

  closeBtn.addEventListener('click', function (e) {
    // Remove event listeners when closing
    document.removeEventListener('click', interceptClicks, true);
    document.removeEventListener('touchstart', interceptClicks, true);
    document.removeEventListener('touchend', interceptClicks, true);

    document.body.removeChild(popup);
    document.cookie = `${cookieName}=true;max-age=${secondsInWeek}`;
  });

  // Track mouse movement for desktop evasion
  function trackMouse(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    moveAwayFromMouse();
  }

  // Track touch for mobile evasion
  function trackTouch(e) {
    if (e.touches.length > 0) {
      mouseX = e.touches[0].clientX;
      mouseY = e.touches[0].clientY;
      moveAwayFromMouse();
    }
  }

  if (/Mobi|Android/i.test(navigator.userAgent)) {
    document.addEventListener('touchmove', trackTouch);
  } else {
    document.addEventListener('mousemove', trackMouse);
  }
}
